import { render } from "./MyAccountView.vue?vue&type=template&id=0e0a7145&scoped=true"
import script from "./MyAccountView.vue?vue&type=script&lang=js"
export * from "./MyAccountView.vue?vue&type=script&lang=js"

import "./MyAccountView.vue?vue&type=style&index=0&id=0e0a7145&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0a7145"]])

export default __exports__